const removeNonQboSupportedChars = (name) => (
  // https://quickbooks.intuit.com/learn-support/en-us/help-article/account-management/acceptable-characters-quickbooks-online/L3CiHlD9J_US_en_US
  // That article does not mention the % sign, but it does seem to work
  // and it's mentioned elsewhere that items do support some special chars
  // but not which ones...
  name.replace(/[^ A-Za-z0-9,.?@%!#'~*();+_-]/g, '').trim()
)

const QBO_ITEM_NAME_MAX_LENGTH = 100

const truncateQboName = (name) => name.slice(0, QBO_ITEM_NAME_MAX_LENGTH)

const itemNameToKey = (name) => (
  removeNonQboSupportedChars(name).toLowerCase()
)

module.exports = { removeNonQboSupportedChars, truncateQboName, itemNameToKey }
